import { gql } from '@apollo/client';

export const GET_LIST_LOCALE = gql`
  query SearchLocale($query: String!, $user_socmed_id: String!) {
    SearchLocale(query: $query, user_socmed_id: $user_socmed_id) {
      data
    }
  }
`;

export const GET_LIST_TARGETING_CLASS = gql`
  query AdTargetingClass($class: String!, $user_socmed_id: String!) {
    AdTargetingClass(class: $class, user_socmed_id: $user_socmed_id) {
      data
    }
  }
`;

export const GET_LIST_GEO_LOCATION = gql`
  query SearchGeoLocation(
    $query: String!
    $location_type: Int!
    $user_socmed_id: String!
  ) {
    SearchGeoLocation(
      query: $query
      location_type: $location_type
      user_socmed_id: $user_socmed_id
    ) {
      data
    }
  }
`;

export const GET_TARGETING_REACH_ESTIMATE = gql`
  query GetTargetingReachEstimate(
    $targeting_spec: Map!
    $user_socmed_id: String!
  ) {
    GetReachEstimate(
      targeting_spec: $targeting_spec
      user_socmed_id: $user_socmed_id
    ) {
      data
    }
  }
`;

export const GET_LIST_APP = gql`
  query GetListApp($user_socmed_id: String!) {
    GetListApp(user_socmed_id: $user_socmed_id, limit: 20) {
      data
    }
  }
`;

export const GET_LIST_PIXEL = gql`
  query GetListPixel($business_id: String!, $user_socmed_id: String!) {
    GetListPixel(
      business_id: $business_id
      user_socmed_id: $user_socmed_id
      limit: 10
    ) {
      data
    }
  }
`;

export const GET_LIST_FACEBOOK_AD_IMAGE_HASHES = gql`
  query GetListFacebookAdImageHashes(
    $parameter: FacebookAdImageParameter!
    $user_socmed_id: String!
  ) {
    GetListFacebookAdImageHashes(
      parameter: $parameter
      user_socmed_id: $user_socmed_id
    ) {
      data
    }
  }
`;

export const GET_LIST_USER_BUSINESS = gql`
  query GetListUserBussines($user_socmed_id: String!) {
    GetListUserBusiness(user_socmed_id: $user_socmed_id, limit: 20) {
      data
    }
  }
`;
